import { SystemModel } from "../../../models/ordersIntegration/SystemModel";
import appConfig from "../../../settings/appConfig";
import { get } from "../../http/apiClient";

export const getSystems = async (): Promise<SystemModel[]> => {
  return await get<SystemModel[]>(
    `${appConfig.baseUrl}${appConfig.URLS.OrdersIntegration.GetSystems}`
  );
};
